/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'
import LifestyleCard from './Card'

const LifestyleSection = ({ cards, description, title }) => {
  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Box
        bg="backgroundBright"
        pt={[7, 9, null, 13]}
        pb={['128px', 8, 9, 10]}
        sx={{
          position: 'relative',
          '&:after': {
            backgroundImage: `url('/images/backgrounds/lifestyle-background-top.svg')`,
            backgroundPosition: [
              'top 0px left 132px',
              'top 0px left -70px',
              null,
              'top center',
            ],
            backgroundRepeat: 'no-repeat',
            backgroundSizeX: '100%',
            backgroundSizeY: '100%',
            content: '""',
            display: 'block',
            height: ['64px', '32px'],
            left: '50%',
            pointerEvents: 'none',
            position: 'absolute',
            top: '100%',
            transform: 'translateX(-50%)',
            width: ['1000px', '2000px'],
          },
        }}
      >
        <Container sx={{ textAlign: 'center' }}>
          <Heading as="h2" mb={2} variant="title2">
            {title}
          </Heading>
          {description && (
            <Grid columns={[1, 12]}>
              <Box
                variant="text.body1"
                sx={{
                  gridColumn: [null, '2 / 12', '3 / 11', '4 / 10'],
                  '& p': { m: 0 },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            </Grid>
          )}
        </Container>
      </Box>
      {cards.map((card, index) => (
        <LifestyleCard
          key={index}
          index={index}
          media={card.media}
          title={card.title}
          description={card.description}
          cta={card.cta}
          last={index === cards.length - 1}
        />
      ))}
    </Box>
  )
}

export default LifestyleSection
